/**
 * State used in rendering SwatchPickerRow
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
